import { Typography, Grid, Paper } from '@mui/material';
import { useEffect, useState } from 'react';
import { useItemColors } from '../../utils/item.utils';
import { StageProps } from '..';

export const CalendarStage = (props: StageProps) => {
  const { data, key, subscription, subscriptionParams, active = false } = props;

  const [hover, setHover] = useState<boolean>(false);

  const { data: stageCache } =
    (subscription && subscriptionParams && subscription(subscriptionParams)) ||
    {};

  const [stageValues, setStageValues] = useState<any>({
    title: data?.title || data?.stage_r?.name || '',
    start_date: data?.start_date,
    due_date: data?.due_date,
    complete: !!data?.outcome,
    status: data?.outcome_r?.name,
  });

  useEffect(() => {
    const stage: any = stageCache;
    if (stage?.id) {
      setStageValues((pv: any) => ({
        ...pv,
        title: stage?.stage_r?.name || pv.title,
        start_date: stage?.start_date,
        due_date: stage?.due_date,
      }));
    }
  }, [stageCache]);

  const {
    item: { border: borderColor, background: backgroundColor, font: color },
  } = useItemColors({
    date: stageValues?.due_date || stageValues?.start_date,
    complete: stageValues?.complete,
  });

  return (
    <Paper
      elevation={0}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={{
        width: '100%',
        pl: 0,
        pr: { xs: 0, sm: 1 },
        py: 0,
        border: `2px solid ${borderColor}`,
        backgroundColor: backgroundColor,
      }}
      key={key}
    >
      <Grid
        container
        alignItems="center"
        rowSpacing={0}
        wrap={hover ? 'wrap' : 'nowrap'}
      >
        <Grid
          item
          container
          rowSpacing={1}
          sx={{ width: { xs: '100%', sm: 'fit-content' }, mr: 'auto' }}
          wrap={hover ? 'wrap' : 'nowrap'}
        >
          <Grid item>
            <Typography
              variant={'subtitle1'}
              color={
                stageValues?.complete || color === 'complete'
                  ? 'disabled'
                  : 'primary'
              }
              sx={{
                verticalAlign: 'middle',
                whiteSpace: hover ? 'wrap' : 'nowrap',
                pl: 2,
                py: 1,
                fontWeight: 600,
                color: theme =>
                  stageValues?.complete || color === 'complete' || !active
                    ? theme.palette.text.disabled
                    : 'inherit',
              }}
            >
              {data?.title || data?.stage_r?.name || ''}&nbsp;
            </Typography>
          </Grid>
        </Grid>

        <Grid item sx={{ width: { xs: '100%', sm: 'fit-content' } }}>
          <Grid container alignItems="center" spacing={1}></Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};
